import { FC, useRef, memo } from "react";
import { extend, ReactThreeFiber, useFrame, useThree } from "@react-three/fiber";
import { Vector3 } from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";

// https://github.com/mrdoob/three.js/blob/dev/examples/jsm/controls/OrbitControls.js
extend({ OrbitControls });
// Typescript declaration: https://github.com/pmndrs/react-three-fiber/issues/130
declare global {
	namespace JSX {
		interface IntrinsicElements {
			orbitControls: ReactThreeFiber.Object3DNode<OrbitControls, typeof OrbitControls>;
		}
	}
}

const CameraHandler: FC<{
	enableZoom: boolean;
	enablePan: boolean;
	enableDamping: boolean;
	dampingFactor: number;
	minDistance: number;
	maxDistance: number;
	minPolarAngle: number;
	maxPolarAngle: number;
}> = ({
	enableZoom,
	enablePan,
	enableDamping,
	dampingFactor,
	minDistance,
	maxDistance,
	minPolarAngle,
	maxPolarAngle
}) => {
	const { camera, gl } = useThree();
	const ref = useRef<OrbitControls>();
	useFrame(() => ref.current?.update());
	return (
		<orbitControls
			ref={ref}
			target={new Vector3(0, 0, 0)}
			enableZoom={enableZoom}
			enablePan={enablePan}
			enableDamping={enableDamping}
			dampingFactor={dampingFactor}
			minDistance={minDistance}
			maxDistance={maxDistance}
			minPolarAngle={minPolarAngle}
			maxPolarAngle={maxPolarAngle}
			args={[camera, gl.domElement]}
		/>
	);
};

export default memo(CameraHandler);
